import React, { Component } from 'react';
import LogoButton from './LogoButton'
import './LogoAndTitleDiv.css'

class LogoAndTitleDiv extends Component {
    // constructor(props){
    //     super(props)
    // }

    

    
    render(){
        const style = {
            //width:360,
            height:100,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
        }

        const mdStyle = {
            color:'#adb4bf',
            fontSize:40,
            fontFamily:'Microsoft JhengHei',
            lineHeight:'100px'
        }

        // const sdStyle = {
        //     display: 'flex',
        //     flexDirection: 'row',
        //     color:'#b0b0b0',
        //     fontSize:12,
        // }

        // const captial = {
        //     color:'#61dafb',
        //     fontSize:12,
        //     fontWeight:'bold',
        //     paddingLeft:2
        
        // }
    
        return(
            <div style={style}>
                <div>
                    <LogoButton/>
                </div>
              
                <div className={"titleGroup"}>
                    <div style={mdStyle}>{"華語電影資料庫"}</div>
                </div>
              
            </div>
        )
    }
}

export default LogoAndTitleDiv
